import { AppConfig } from '../config/config'
import AWS from 'aws-sdk'

export function getS3Key(url) {
    if (!url) {
        return null
    }

    const pattern = /.*(nerit_mercado.*(\/)(?!.*\/)).*/
    return url.replace(pattern, "$1")
}


export function uploadToS3(schema, file, type, _public) {
    const key = `nerit_mercado/${schema}/${type}/${file.name}`

    AWS.config.update({
        region: AppConfig.aws.region,
        credentials: AppConfig.aws.credentials
    })

    const params = {
        Body: file,
        Bucket: AppConfig.aws.bucketName,
        Key: key,
        ContentType: file.contentType,
        ACL: _public ? 'public-read' : 'private'
    }

    const bucket = new AWS.S3({})

    return new Promise((resolve, reject) => {
        bucket.upload(params).send((err, data) => {
            if (err) {
                reject(err)
            } else {
                resolve(data.Location)
            }
        })
    })
}

export function removeFromS3(url) {
    const key = ''

    AWS.config.update({
        region: AppConfig.aws.region,
        credentials: AppConfig.aws.credentials
    })

    const params = {
        Bucket: AppConfig.aws.bucketName,
        Key: key
    }

    const bucket = new AWS.S3({})

    return new Promise((resolve, reject) => {
        bucket.deleteObject(params, (err, data) => {
            if (err) {
                console.log(err, 'erro')
                reject(err)
            } else {
                console.log(data, 'dados')
                resolve(data)
            }
        })
    })
}

export function getFromS3(path, title) {
    console.log(`${path}${title}`)
    const key = `${path}${title}`

    AWS.config.update({
        region: AppConfig.aws.region,
        credentials: AppConfig.aws.credentials
    })

    const params = {
        Bucket: AppConfig.aws.bucketName,
        Key: key
    }

    const bucket = new AWS.S3({})

    return new Promise((resolve, reject) => {
        bucket.getObject(params, (err, data) => {
            if (err) {
                console.log(err, 'erro')
                reject(err)
            } else {
                resolve(data)
            }
        })
    })
}




// WEBPACK FOOTER //
// ./src/helpers/aws.js